/*
* */

var ratingBlock = function(el){
	var box = document.getElementById('illumination'),
		nextBtn,
		modules,
		path = function(){
			var part = APP.vars.isDev ? '/_src/layouts/ratingBlockModule' : '';
			var path = part + '/widget/votes/';
			return path;
		}(),
		xhr,
		isSending = false,
		isFirstPage = true,
		addModules = function(){
			modules = APP.modules.run(el, 'data-ratingBlock-modules');
			modules.Rating[0].successExec = showNext;
			nextBtn = el.querySelector('[data-ratingBlock-next]');
			nextBtn.addEventListener('click', showNext);
		},
		destroyModules = function(){
			APP.modules.destroy(modules);
			nextBtn.removeEventListener('click', showNext);
			nextBtn = null;
		},
		showNext = function(){
			if(isFirstPage){
				var xhrPath = path + '?page=first';
			} else {
				var xhrPath = path;
				if(isSending) return false;
				isSending = true;
				el.classList.add('js-sending');
			}

			//чтобы подгружался нужный модуль
			if(APP.vars.isDev){
				var sign = isFirstPage ? '&' : '?';
				xhrPath += sign + (APP.vars.isMobile ? 'isMobile=1' : '&isMobile=0');
			}

			xhr = new XMLHttpRequest();
			xhr.open("GET", xhrPath, true);
			xhr.setRequestHeader("X-Request-Ajax","1");
			xhr.onload = addData;
			xhr.send('');
		},
		addData = function(){
			var answer = JSON.parse(xhr.responseText);
			if(!isFirstPage){
				destroyModules();
			}
			isFirstPage = false;
			if(!answer.status){
				el.parentNode.removeChild(el);
			} else {
				el.innerHTML = answer.content;
				addModules();
				isSending = false;
				el.classList.remove('js-sending');
			}
		};
	//
	showNext();
}

export {ratingBlock};
